import { useAppDispatch } from 'lib/centralStore';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { virtualCli } from 'types/swagger';
import { isServerSide } from 'utility/constant';
import { isCrawler, isTruthy } from 'utility/functions';
import { feedVirtualNav } from './actions';
import { VirtualNav } from './types';

const indexing = isCrawler();

export const useVirtualNavSnapshot = (data: VirtualNav) => {
  const dispatch = useAppDispatch();
  const { isReady } = useRouter();
  const [isCompleted, setCompleted] = useState(false);

  const menuData = useRef<VirtualNav>(data);
  const isInitialized = useRef(false);

  const doFetch = useCallback(async () => {
    const ts = new Date().getTime();
    virtualCli.virtuali
      .menuList()
      .then((response) => {
        if (isTruthy(response.ok)) {
          menuData.current = {
            ts,
            menu: response.data,
          };
        }
      })
      .finally(() => {
        setCompleted(true);
      });
  }, []);

  useEffect(() => {
    if (isServerSide || indexing) {
      return;
    }

    if (!isInitialized.current) {
      isInitialized.current = true;
      doFetch();
    }
  }, [doFetch]);

  useEffect(() => {
    if (isReady && isCompleted) {
      // once HYDRATION and FETCH both completed -> FEED with fresh data
      setCompleted(false);
      dispatch(feedVirtualNav(menuData.current));
    }
  }, [isReady, isCompleted]);

  return Promise.resolve();
};
